import React from "react";
import Input from "./input";

const IconInput = React.forwardRef(
    (
        {
            iconClassName,
            Icon,
            value = "",
            validation = true,
            validationType = null,
            formState = null,
            setFormState = null,
            overrideClasses = "text-gray-700 w-full mb-1 pl-10 pr-3 py-2 rounded border border-gray-200 focus:outline-blue-500",
            minValue = null,
            maxValue = null,
            minimumLength = null,
            maximumLength = null,
            ...props
        },
        ref
    ) => {
        let iconDefaultClassNames = "w-5 h-5 text-gray-400";
        if (iconClassName)
            iconDefaultClassNames = `${iconDefaultClassNames} ${iconClassName}`;
        return (
            <>
                <div className="relative">
                    <div className="absolute inset-y-0 start-0 flex items-start pt-3 ps-3.5 pointer-events-none">
                        <Icon className={iconDefaultClassNames} />
                    </div>
                    <Input
                        ref={ref}
                        value={value || ""}
                        validation={validation}
                        validationType={validationType}
                        formState={formState}
                        setFormState={setFormState}
                        overrideClasses={overrideClasses}
                        minValue={minValue}
                        maxValue={maxValue}
                        minimumLength={minimumLength}
                        maximumLength={maximumLength}
                        {...props}
                    />
                </div>
            </>
        );
    }
);

export default IconInput;
